import { Box, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import Alert from '/@/components/bayer/alert';
import Markdown from '/@/components/markdown';
import { _ } from '/@/locale';
import Acceleron from '/@/v3/styles/assets/logos/acceleron.svg';
import type { TTab } from '../..';
import { FeaturesMiniCard } from '../features';
import { H2HMiniCard } from '../h2h';
import { MetricsMiniCard } from '../metrics';
import PhenologyMiniCard from '../phenology-minicard';

const ProductExplorationGeneral = ({
    product,
    setTab,
    type = 'crop_protection',
}: {
    product: any;
    setTab: (tab: TTab) => void;
    type?: string;
}) => {
    const {
        peDescription,
        peAlertMessage,
        peIdealPositioning,
        peCompetitiveAdvantages,
        peTargetProducerProfile,
        technologies,
    } = product || {};

    return (
        <Grid2 container spacing={4}>
            <Grid2 xs={12} sm={7} md={8}>
                <Stack spacing={4}>
                    {_(peAlertMessage) && (
                        <Alert severity='blue' icon={<Box />}>
                            {_(peAlertMessage)}
                        </Alert>
                    )}
                    {_(peDescription) && (
                        <Stack spacing={2}>
                            <Typography variant='body1' color='primary'>
                                <Markdown>{_(peDescription)}</Markdown>
                            </Typography>
                        </Stack>
                    )}
                    {_(peIdealPositioning) && (
                        <Stack spacing={2}>
                            <Typography variant='h5' color='primary'>
                                {_('Posicionamiento ideal')}
                            </Typography>
                            <Typography variant='body1' color='primary'>
                                <Markdown>{_(peIdealPositioning)}</Markdown>
                            </Typography>
                        </Stack>
                    )}
                    {_(peCompetitiveAdvantages) && (
                        <Stack spacing={2}>
                            <Typography variant='h5' color='primary'>
                                {_('Ventajas Competitivas')}
                            </Typography>
                            <Typography variant='body1' color='primary'>
                                <Markdown>{_(peCompetitiveAdvantages)}</Markdown>
                            </Typography>
                        </Stack>
                    )}
                    {_(peTargetProducerProfile) && (
                        <Stack spacing={2}>
                            <Typography variant='h5' color='primary'>
                                {_('Perfil de productor objetivo')}
                            </Typography>
                            <Typography variant='body1' color='primary'>
                                <Markdown>{_(peTargetProducerProfile)}</Markdown>
                            </Typography>
                        </Stack>
                    )}
                </Stack>
            </Grid2>
            <Grid2 xs>
                <Stack spacing={4}>
                    {(technologies?.length || 0) > 0 && (
                        <Stack spacing={2}>
                            <Typography variant='overline' color='primary'>
                                {_('Tecnologías disponibles')}
                            </Typography>
                            <Stack direction='row' spacing={2}>
                                {technologies.map(({ id, logoImage }: any) => (
                                    <Box key={id} component='img' src={logoImage} height={'25px'} />
                                ))}
                            </Stack>
                        </Stack>
                    )}
                    {type !== 'crop_protection' && (
                        <Stack spacing={2}>
                            <Typography variant='overline' color='primary'>
                                {_('Tratamiento de semilla')}
                            </Typography>
                            <Stack direction='row' spacing={2}>
                                <Box component='img' src={Acceleron} height={'40px'} />
                            </Stack>
                        </Stack>
                    )}
                    <Stack spacing={2}>
                        {type !== 'crop_protection' ? (
                            <>
                                <H2HMiniCard product={product} onClick={() => setTab('h2h')} />
                                <MetricsMiniCard product={product} onClick={() => setTab('metrics')} />
                                <PhenologyMiniCard productId={product.id} crop={type} />
                            </>
                        ) : (
                            <FeaturesMiniCard product={product} onClick={() => setTab('features')} />
                        )}
                    </Stack>
                </Stack>
            </Grid2>
        </Grid2>
    );
};

export default ProductExplorationGeneral;
